<div class="disclaimer-reference" [ngClass]="{ safari: isSafari }">
  <div class="disclaimer-message">
    @if (sensitiveMessage) {
      <span class="sensitive-message"> {{ sensitiveMessage }} </span>
    }
    @if (isNotApplicable) {
      <span class="adding-disclaimer">{{ "nonApplicable.message" | pubLang: store.pubInfo?.lang }}</span>
    }
    @if (dataDisclosure) {
      <span class="data-disclosure"> {{ dataDisclosure }} </span>
    }
    <span [class.black]="isNotApplicable"> {{ "disclaimer.print" | pubLang: store.pubInfo?.lang }}</span>
  </div>
</div>

@if (!isPreprint) {
  <o-loading [isLoading]="isLoading"></o-loading>
}

<table class="content-provider-table">
  <thead>
    <tr class="no-highlight-row">
      <th>
        <div class="disclaimer-top" [ngClass]="{ safari: isSafari }">
          @if (selectedCriteria.version || selectedCriteria.serialno) {
            <div class="applic-filter">
              {{
                "print.warning.message"
                  | pubLang
                    : store.pubInfo?.lang
                    : {
                        applic:
                          "applicability.criteria"
                          | pubLang
                            : store.pubInfo?.lang
                            : {
                                model: selectedCriteria.model,
                                version: selectedCriteria.version || "*",
                                serialno: selectedCriteria.serialno || "*"
                              }
                      }
              }}
            </div>
          }
          <div class="disclaimer">
            <div class="left">
              {{ store.pubInfo?.verbatimText }} Rev.{{
                store.pubInfo?.revision | parseRevision: store.pubInfo?.isPackagePDF
              }}
              {{ store.duObject?.duReference }} {{ pubIdParsed }}
            </div>
            <div class="right">
              Printed by {{ store.user?.samAccountName }} on {{ currentDate | date: "yyyy-MM-dd" }}
            </div>
          </div>
        </div>
      </th>
    </tr>
  </thead>
  <tbody>
    <tr class="no-highlight-row">
      <td>
        <div
          [ngClass]="{
            safariContent: isSafari,
            iosContent: isIos,
            cordovaContent: isCordova,
            'mma-wrap': isMMA,
            hide: errorMessage,
            'router-outlet-wrap': !errorMessage
          }">
          @if ((isNotApplicable && !isPreprint) || dataDisclosure) {
            <div oSticky [stickyOffset]="60" class="header__not-applicable">
              <mat-icon svgIcon="alert-outline" class="black"></mat-icon>
              @if (isNotApplicable && !isPreprint) {
                <span class="left"> {{ "nonApplicable.message" | translate }} {{ dataDisclosure ? " - " : "" }} </span>
              }
              @if (dataDisclosure) {
                <span>{{ dataDisclosure }}</span>
              }
            </div>
          }
          <o-impacting-warning
            [ngClass]="{
              'warning-ipc': ipcView,
              'only-print': store.view === 'stepbystep' || store.view === 'fullscreen',
              'half-view': store.view === 'media'
            }"></o-impacting-warning>
          <mat-sidenav-container class="dm-items-container" [hasBackdrop]="!store.pubInfo?.capabilities?.notesInline">
            @if (ipcView || pdfView || store.isEncapsulatedPdf || store.inPrint) {
              @let notesInPanel = store.currentNotes | notesFilter: notesFilterMode.PANEL : !!store.ipcXML;
              @let noDmItems = !notesInPanel.length && !store.currentComments.length;
              <mat-sidenav
                (closedStart)="store.dmItemsDrawerOpen = false"
                (opened)="focusFirstEditNote()"
                class="dm-items-sidenav"
                autoFocus="false"
                [position]="store.inPrint ? 'start' : 'end'"
                [opened]="store.dmItemsDrawerOpen && !store.inPrint"
                [ngClass]="{
                  withBand: isPreprint || isNotApplicable,
                  'no-dm-items': noDmItems,
                  'side-by-side': preprintSideBySide
                }">
                <div class="close-drawer">
                  <button
                    mat-icon-button
                    type="button"
                    title="close button"
                    class="close-button"
                    (click)="store.dmItemsDrawerOpen = false">
                    <mat-icon svgIcon="close" />
                  </button>
                </div>
                <div class="dm-items-content">
                  <mat-expansion-panel
                    class="dm-items-list"
                    togglePosition="before"
                    [class.invisible]="!notesInPanel.length"
                    [(expanded)]="store.isNotesPanelOpen">
                    <mat-expansion-panel-header>
                      <mat-panel-title id="fulltext-notes">
                        {{ "notes.label" | translate }} ({{ notesInPanel.length }})
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    @for (note of notesInPanel; track note._id) {
                      <o-note class="from-fulltext" [item]="note" />
                    }
                  </mat-expansion-panel>
                  <mat-expansion-panel
                    class="dm-items-list"
                    togglePosition="before"
                    [class.invisible]="!store.currentComments.length"
                    [(expanded)]="store.isCommentsPanelOpen">
                    <mat-expansion-panel-header>
                      <mat-panel-title id="fulltext-comments">
                        {{ "comments.label" | translate }} ({{ store.currentComments.length }})
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    @for (comment of store.currentComments; track comment._id) {
                      <o-comment [comment]="comment" />
                    }
                  </mat-expansion-panel>
                </div>
              </mat-sidenav>
            }
            <mat-sidenav-content
              [class.non-applicable-content]="isNotApplicable || isPreprint"
              [class.applicable-content]="!isNotApplicable && !isPreprint">
              <router-outlet (activate)="scrollTop()" />
            </mat-sidenav-content>
          </mat-sidenav-container>
        </div>
      </td>
    </tr>
  </tbody>
</table>

@if (errorMessage) {
  <div>
    <o-not-found [errorMessage]="errorMessage" />
  </div>
}
